import React from "react";
import { TiSocialFacebook } from "react-icons/ti";
import { AiOutlineYoutube } from "react-icons/ai";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaTelegramPlane } from "react-icons/fa";

import "./SocialMediaLinks.scss";

export default function SocialMediaLinks() {
  return (
    <div className="social_links">
      <div className="fb social_icon">{<TiSocialFacebook />}</div>
      <div className="youtube social_icon">
        <AiOutlineYoutube />
      </div>
      <div className="instagram social_icon">
        <AiOutlineInstagram />
      </div>
      <div className="telegram social_icon">
        <FaTelegramPlane />
      </div>
    </div>
  );
}
